import {Injectable, ElementRef} from '@angular/core';
import {WindowRefService} from './../window-ref.service';
import {includes} from 'lodash';

@Injectable({
    providedIn: 'root'
})
export class StripeService {
    constructor(private winRef: WindowRefService) {}

    private locale: string[] = [
        'ar', 'da', 'de', 'en', 'es', 'fi', 'fr', 'he', 'it', 'ja', 'lt', 'lv', 'ms', 'nb', 'nl', 'pl', 'pt', 'ru', 'sv', 'zh'
    ];
    /*
     * Calls stripe.confirmCardPayment which creates a pop-up modal to
     * prompt the user to enter extra authentication details without leaving your page
     */
    pay(data: {stripe: any, card: any, clientSecret: string}): Promise<any> {

        //this.changeLoadingState(true);

        // Initiate the payment.
        // If authentication is required, confirmCardPayment will automatically display a modal
        let promise: Promise<any> = data.stripe.confirmCardPayment(data.clientSecret, {payment_method: {card: data.card}})
            ;
        return promise;
    }

    // Set up Stripe.js and Elements to use in checkout form
    setupElements(stripe, data, cardInfo: ElementRef) {
        let _stripe = stripe(data.stripePublishableKey);
        let locale = 'en';
        if (includes(this.locale, this.winRef.appConfigSite.defaultlangue)) {
            locale = this.winRef.appConfigSite.defaultlangue;
        }
        let elements = _stripe.elements({locale: locale});
        let style = {
            base: {
                color: "#32325d",
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                fontSmoothing: "antialiased",
                fontSize: "16px",
                "::placeholder": {
                    color: "#aab7c4"
                }
            },
            invalid: {
                color: "#fa755a",
                iconColor: "#fa755a"
            }
        };

        let card = elements.create("card", {style: style});
        card.mount(cardInfo.nativeElement);

        return {
            stripe: _stripe,
            card: card,
            clientSecret: data.stripeClientSecret
        };
    };

}
